import { useRouter } from 'next/router'
import { CSSProperties } from 'react'

import ROUTES from '~/shared/constants/routes.const'

const usePageBackground = (): { cx: string; style: CSSProperties | undefined } => {
  const router = useRouter()
  const { asPath: currentPageUrl } = router

  if (currentPageUrl.includes(ROUTES.BOOTCAMP)) {
    const style = {
      backgroundSize: '55%',
      backgroundPosition: '600px 100%',
    }

    return {
      cx: '',
      style,
    }
  }

  return {
    cx: '',
    style: undefined,
  }
}

export default usePageBackground
